module.exports = __webpack_public_path__ + "static/media/wallpaper-salary-highway.9643fa6f.png";